import { parse } from 'papaparse';

/**
 * A promisified version of the PapaParse `parse` function.
 * Transforms headers into their JSON equivalent for easier manipulation.
 *
 * Header transformations:
 * - `*Code` -> `code`
 * - `*Name` -> `name`
 * - `description` -> `description`
 * - `*Report Code` -> `reportCode`
 * - `*Type` -> `type`
 * - `*Class` -> `class`
 *
 * Note: No validation is applied to the parsed data.
 *
 * @param {File|String} file - The file or CSV string to be parsed.
 * @returns {Promise<Object>} A promise that resolves to the parsed data.
 */
export function parseAsync(file: File): Promise<unknown[]> {
    return new Promise((resolve, reject) => {
        parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: function ({ data }) {
                resolve(data);
            },

            transformHeader(header) {
                switch (header) {
                    case '*Code':
                        return 'code';
                    case '*Name':
                        return 'name';
                    case 'Description':
                        return 'description';
                    case '*Report Code':
                        return 'reportCode';
                    case '*Type':
                        return 'type';
                    case '*Class':
                        return 'class';
                    default:
                        return header;
                }
            },
            error: function (error) {
                reject(error);
            },
        });
    });
}
